import { MetadataProperty, simpleMetadataDecoratorApplicator } from "@spscommerce/utils";

export interface SpsActionDescriptor {
    label?: MetadataProperty<string>;
    icon?: MetadataProperty<string>;
    caption?: MetadataProperty<string>;
    disabled?: MetadataProperty<boolean>;
    isLink?: MetadataProperty<boolean>;
    href?: MetadataProperty<string>;
}

export const SPS_ACTION_DEFAULTS: SpsActionDescriptor = {
    icon: "",
    label: "",
    caption: "",
    disabled: false,
    isLink: false
};

export interface SpsActionMethod extends SpsActionDescriptor {
    (...args: any[]): any;
}

export function SpsAction(actionDescriptor: SpsActionDescriptor): MethodDecorator {
    return (
        target: any,
        key: PropertyKey,
        descriptor: TypedPropertyDescriptor<any>
    ): TypedPropertyDescriptor<any> =>
        simpleMetadataDecoratorApplicator<SpsActionDescriptor, any>(
            actionDescriptor,
            SPS_ACTION_DEFAULTS,
            target,
            key,
            descriptor
        );
}
